import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";

// ── Global fetch interceptor ──────────────────────────────────────────
// Automatically attaches the correct Authorization header for API calls.
// Admin routes (/api/admin/*) use the adminToken; all other authenticated
// routes use jwt_token.  Existing headers are never overwritten.
const _origFetch = window.fetch;
window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';

  // Only intercept calls to our own API
  if (url.includes('/api/')) {
    init = init || {};
    const headers = new Headers(init.headers || {});

    // Don't overwrite if the caller already set Authorization
    if (!headers.has('Authorization')) {
      if (url.includes('/api/admin/')) {
        const adminToken = localStorage.getItem('adminToken');
        if (adminToken) {
          headers.set('Authorization', `Bearer ${adminToken}`);
        }
      } else {
        const jwtToken = localStorage.getItem('jwt_token');
        if (jwtToken) {
          headers.set('Authorization', `Bearer ${jwtToken}`);
        }
      }
    }

    init.headers = headers;
  }

  return _origFetch.call(this, input, init).then((response) => {
    if ((response.status === 401 || response.status === 403) && url.includes('/api/admin/')) {
      localStorage.removeItem('adminToken');
      if (!window.location.pathname.includes('/adminlogin')) {
        window.location.href = '/adminlogin';
      }
    }
    return response;
  });
};


window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = event && event.reason ? String(event.reason) : '';
    if (reason.includes('flatpickr') || reason === 'Script error.') {
      event.preventDefault();
      return;
    }
  } catch (e) {
   
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "492344913620-o8b4bm7lepbok9bdm76ha1ld8el4g8qp.apps.googleusercontent.com"}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

